import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Address } from '../models/address.model';
import { GlobalUser } from '../models/global.user.model';
import { MockData } from './../mock/data.mock';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  endpoint = `${environment.apiFramework}`;
  myInfo$ = new BehaviorSubject<GlobalUser>(null);

  constructor(private http: HttpClient, private mockData: MockData) {}

  getLoggedUser(): Observable<GlobalUser> {
    return this.http.get<any>(`${this.endpoint}/users/myinfo`);
  }

  //
  getMyInfo(): Observable<GlobalUser> {
    return this.myInfo$.asObservable();
  }

  setMyInfo(user: GlobalUser) {
    this.myInfo$.next(user);
  }

  updateProfile(user: any): Observable<any> {
    return this.http.put<any>(`${this.endpoint}/users/${user.id}`, user).pipe(take(1));
  }

  getUserAddresses(id: string): Observable<Address> {
    return this.http.get<any>(
      `${this.endpoint}/addresses?$select=id,name,street,city,neighborhood,extrainfo,zipCode,housenumber,referenceid,socialMedias&$expand=state&$filter=referenceId eq ${id}`
    );
  }

  getAddressById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.endpoint}/addresses?$select=id,name,street,city,neighborhood,extrainfo,zipCode,housenumber,referenceid,socialMedias&$expand=state&$filter=id eq ${id}`
    );
  }

  postUserAddress(address: any): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/addresses`, address).pipe(take(1));
  }

  updateUserAddress(id: string, address: any): Observable<any> {
    return this.http.put<any>(`${this.endpoint}/addresses/${id}`, address).pipe(take(1));
  }

  deleteUserAddress(id: string): Observable<any> {
    return this.http.delete<any>(`${this.endpoint}/addresses/${id}`).pipe(take(1));
  }

  getStateId(stateCode: string) {
    return this.http.get<any>(`${this.endpoint}/states?$select=id,statecode&$filter=statecode eq '${stateCode}'`);
  }

  getUserApps(): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/applications/GetAllForUser`);
  }

  sendMedicData(data: any): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/users`, data);
  }

  getTimeZones(): Observable<any> {
    return this.http.get<any>(`${this.endpoint}/TimeZones`);
  }

  setUser(user: any): Observable<any> {
    // TODO: Alterar para uma tipagem adequada
    return this.http.post<any>(`${this.endpoint}/Users`, user);
  }
  setUserLoggedAdmin(user: any): Observable<any> {
    // TODO: Alterar para uma tipagem adequada
    return this.http.post<any>(`${this.endpoint}/Auth/Register`, user);
  }

  getBeneficiaryMock() {
    let dados = this.mockData.getBeneficiary;
    return of(dados);
  }

  verifyStudent(nationalId: string): Observable<any> {
    return this.http.get<any>(
      `${environment.api}/vwstudents?$filter=nationalId eq '${nationalId}'&$select=vwStudentId,name,emails,phones,nationalId,birthdate,photo,unitCode,gender`
    );
  }

  getUser(nationalId: string) {
    return new Promise<{ student?: any; vwStudent?: any; user?: any }>((resolve, reject) => {
      let responses: { student?: any; vwStudent?: any; user?: any } = {};
      this.http
        .get(
          `${environment.api}/Students?$expand=user($select=id,nickName,userCode,birthPlace,nationality,nationalId2,gender,alternativeEmail,active,addresses,medias,avatar,email,name,nationalId,birthdate)&$select=id,nationalId,keyboardPassword,goals,lockKeyboard,userId,restrictions,canBeReleased,fingerprint&$filter=nationalId eq ('${nationalId}')`
        )
        .subscribe(
          (response: any) => {
            if (response?.value[0]) {
              responses.student = response.value[0];
              if ((responses.vwStudent || responses.vwStudent === null) && (responses.user || responses.user === null))
                resolve(responses);
              return;
            }

            responses.student = null;
            if ((responses.vwStudent || responses.vwStudent === null) && (responses.user || responses.user === null))
              return resolve(responses);
            if (responses.vwStudent === null && responses.user === null) reject('NOT_FOUND');
          },
          (e) => reject(e)
        );

      this.http
        .get(
          `${environment.api}/vwstudents?$filter=nationalId eq '${nationalId}'&$select=vwStudentId,name,emails,phones,nationalId,birthdate,photo,unitCode,gender`
        )
        .subscribe(
          (response: any) => {
            if (response?.value[0]) {
              responses.vwStudent = response.value[0];
              if ((responses.student || responses.student === null) && (responses.user || responses.user === null))
                resolve(responses);
              return;
            }

            responses.vwStudent = null;
            if ((responses.student || responses.student === null) && (responses.user || responses.user === null))
              return resolve(responses);
            if (responses.student === null && responses.user === null) reject('NOT_FOUND');
          },
          (e) => reject(e)
        );

      this.http
        .get(
          `${environment.apiFramework}/users?$filter=nationalId eq '${nationalId}'&$select=id,nickName,userCode,birthPlace,nationality,nationalId2,gender,alternativeEmail,active,addresses,medias,avatar,email,name,nationalId,birthdate`
        )
        .subscribe(
          (response: any) => {
            if (response?.value[0]) {
              responses.user = response.value[0];
              if ((responses.vwStudent || responses.vwStudent === null) && (responses.student || responses.student === null))
                resolve(responses);
              return;
            }

            responses.user = null;
            if ((responses.student || responses.student === null) && (responses.vwStudent || responses.vwStudent === null))
              return resolve(responses);
            if (responses.student === null && responses.vwStudent === null) reject('NOT_FOUND');
          },
          (e) => reject(e)
        );
    });
  }

  //pesquisa agora é feita por cpf
  getUserById(id: string) {
    return new Promise<{ student?: any; vwStudent?: any; user?: any }>((resolve, reject) => {
      this.http
        .get(
          `${environment.api}/Students?$expand=user($select=id,nickName,userCode,birthPlace,nationality,nationalId2,gender,alternativeEmail,active,addresses,medias,avatar,email,name,nationalId,birthdate)&$select=id,nationalId,keyboardPassword,goals,lockKeyboard,userId,restrictions,canBeReleased,fingerprint&$filter=nationalId eq '${id}'`
        )
        .subscribe(
          (responseStudent: any) => {
            if (responseStudent?.value[0]) {
              this.http
                .get(
                  `${environment.api}/vwstudents?$filter=nationalId eq '${responseStudent?.value[0].user.nationalId}'&$select=vwStudentId,name,emails,phones,nationalId,birthdate,photo,unitCode,gender`
                )
                .subscribe(
                  (responseVwStudent: any) => {
                    resolve({ student: responseStudent.value[0], vwStudent: responseVwStudent.value[0] });
                  },
                  (e) => reject(e)
                );
              return;
            }
            this.http
              .get(
                `${environment.apiFramework}/users?$filter=nationalId eq '${id}'&$select=id,nickName,userCode,birthPlace,nationality,nationalId2,gender,alternativeEmail,active,addresses,medias,avatar,email,name,nationalId,birthdate`
              )
              .subscribe(
                (responseUser: any) => {
                  if (responseUser?.value[0]) {
                    return resolve({ user: responseUser.value[0] });
                  }
                  return reject('NOT_FOUND');
                },
                (e) => reject(e)
              );
          },
          (e) => reject(e)
        );
    });
  }

  saveUser(body: any): Observable<any> {
    return this.http.post(`${environment.apiFramework}/users`, body);
  }
  saveStudent(body: any): Observable<any> {
    return this.http.post(`${environment.api}/Students`, body);
  }

  updateUser(body: any, id: string): Observable<any> {
    return this.http.put(`${environment.apiFramework}/users/${id}`, { ...body, id });
  }
  updateStudent(body: any): Observable<any> {
    return this.http.put(`${environment.api}/Students/${body.id}`, body);
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete(`${environment.apiFramework}/users/${id}`);
  }
  deleteStudent(id: string, onlyUser: boolean): Observable<any> {
    return this.http.delete(`${environment.api}/Students/${id}?removeOnlyUser=${onlyUser ? 'true' : 'false'}`);
  }
}
